import {
  AddressDto,
  EmailAddressDto,
  PhoneNumberDto,
  UserDto,
} from '@act/shared/data-transfer-objects';
import { createAction } from '@reduxjs/toolkit';
import { membersRequests } from '../requests/members.request';
import { userRequests } from '../requests/users.request';
import { createApiThunk } from '../utils/apiThunk';

export const getMember = createApiThunk(membersRequests.getMember);
export const getMemberStatuses = createApiThunk(
  membersRequests.getMemberStatuses
);
export const getMembersForMap = createApiThunk(
  membersRequests.getMembersForMap
);
export const getPaginatedMembersForTable = createApiThunk(
  membersRequests.getPaginatedMembersForTable
);
export const getMemberFilters = createApiThunk(
  membersRequests.getMemberFilters
);

type NewMembersPayload = { members: UserDto[] };
export const newMembersLoaded = createAction<NewMembersPayload>(
  'members/newMembersLoaded'
);

export const getMemberInfo = createApiThunk(userRequests.getUserDetails);

export const patchMemberInfo = createApiThunk(userRequests.patchMemberInfo);
export const putRaceEthnicityInfo = createApiThunk(
  userRequests.putRaceEthnicityInfo
);

export const createPhoneNumber = createApiThunk(userRequests.createPhoneNumber);
export const deletePhoneNumber = createApiThunk(userRequests.deletePhoneNumber);
export const updatePhoneNumber = createApiThunk(userRequests.updatePhoneNumber);

export const createAddress = createApiThunk(userRequests.createAddress);
export const deleteAddress = createApiThunk(userRequests.deleteAddress);
export const updateAddress = createApiThunk(userRequests.updateAddress);
export const updatePrimaryAddress = createApiThunk(
  userRequests.updatePrimaryAddress
);

export const updatedPrimaryAddressSuccess = createAction<{
  userId: string;
  address: AddressDto;
}>('member/updatedPrimaryAddressSuccess');

export const updatedAddressSuccess = createAction<{
  userId: string;
  addressId: number;
  address: AddressDto;
}>('member/updatedAddressSuccess');

export const createAddressSuccess = createAction<{
  userId: string;
  address: AddressDto;
}>('member/createAddressSuccess');

export const deletedAddressSuccess = createAction<{
  userId: string;
  addressId: number;
}>('member/deletedAddressSuccess');

export const createEmailAddressSuccess = createAction<{
  memberId: string;
  emailAddress: EmailAddressDto;
}>('member/createEmailAddressSuccess');

export const updatedEmailAddressSuccess = createAction<{
  memberId: string;
  emailAddressId: number;
  emailAddress: EmailAddressDto;
}>('member/updatedEmailAddressSuccess');

export const deletedEmailAddressSuccess = createAction<{
  memberId: string;
  emailAddressId: number;
}>('member/deletedEmailAddressSuccess');

export const updatedPrimaryPhoneNumberSuccess = createAction<{
  userId: string;
  phoneNumber: PhoneNumberDto;
}>('member/updatedPrimaryPhoneNumberSuccess');

export const createPhoneNumbeUserSuccess = createAction<{
  userId: string;
  phoneNumber: PhoneNumberDto;
}>('member/createPhoneNumberSuccess');

export const updatedPhoneNumberUserSuccess = createAction<{
  userId: string;
  phoneNumberId: number;
  phoneNumber: PhoneNumberDto;
}>('member/updatedPhoneNumberSuccess');
